// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopArticlesListByCategoryPagingResultModel from '../../model/shop-articles-list-by-category-paging-result-model';
import ShopArticlesListByCategoryPagingResultDTO from '../dto/shop-articles-list-by-category-paging-result-dto';
import dtoSchema from '../schemas/shop-articles-list-by-category-paging-result-schema';
import ShopArticlesListByCategoryModel from '../../model/shop-articles-list-by-category-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ShopArticlesListByCategoryPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopArticlesListByCategoryPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopArticlesListByCategoryModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: ShopArticlesListByCategoryModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<ShopArticlesListByCategoryPagingResultDTO>): ShopArticlesListByCategoryPagingResultModel;
  static toModel(dto: DeepPartial<ShopArticlesListByCategoryPagingResultDTO> | undefined | null): ShopArticlesListByCategoryPagingResultModel | undefined;
  static toModel(dto: DeepPartial<ShopArticlesListByCategoryPagingResultDTO> | undefined | null): ShopArticlesListByCategoryPagingResultModel | undefined {
    return dto ? new ShopArticlesListByCategoryPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopArticlesListByCategoryPagingResultModel> | ShopArticlesListByCategoryPagingResultModel): ShopArticlesListByCategoryPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as ShopArticlesListByCategoryPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopArticlesListByCategoryPagingResultModel, can not map to ShopArticlesListByCategoryPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
